const NavigationButtonLabelStyle = `
  font-size: 9px;
  letter-spacing: .75px;
  line-height: 10px;
`;

export default NavigationButtonLabelStyle;
